import { biLogger } from '../biLogger';
import { selectBiData } from '../selectors';
import { AnswerFeedbackReasonButtonClickedBiData, BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotAnswerFeedbackReasonButtonClicked: BiEventLogger<
  AnswerFeedbackReasonButtonClickedBiData
> = async (state, data) => {
  const biData = selectBiData(state);
  const { sessionId, chatbotView } = await getRuntimeDataForBi(state);

  biLogger.chatbotAnswerFeedbackReasonButtonClicked({
    session_id: sessionId,
    chatbot_view: chatbotView,
    widget_view_mode: undefined,
    conversation_id: biData.conversationId,
    ab_test_version: undefined,
    message_id: data.messageId,
    feedback_reason_button_type: data.reasonType,
  });
};
